// src/components/Learnings.jsx
import React, { useState } from "react";
import "../assets/css/Learnings.css";
import BredcrumpImage from "../assets/images/skin-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";

import demoLogo from "../assets/images/Skinnversity-Logo.png";

// workshop images
import w1_1 from "../assets/images/Learnings/Learning1.jpeg";
import w1_2 from "../assets/images/Learnings/Learning2.jpeg";
import w1_3 from "../assets/images/Learnings/Learning3.jpeg";
import w1_4 from "../assets/images/Learnings/Learning4.jpeg";
import w1_5 from "../assets/images/Learnings/Learning5.jpeg";
import w1_6 from "../assets/images/Learnings/Learning6.jpeg";

import w2_1 from "../assets/images/Learnings/Learning7.jpeg";
import w2_2 from "../assets/images/Learnings/Learning8.jpeg";
import w2_3 from "../assets/images/Learnings/Learning9.jpeg";
import w2_4 from "../assets/images/Learnings/Learning10.jpeg";
import w2_5 from "../assets/images/Learnings/Learning3.jpeg";
import w2_6 from "../assets/images/Learnings/Learning6.jpeg";

const Learnings = () => {
  const heroText = [
    `At Biopharmacieaa, we focus on advancing patient care through three core therapeutic areas involving clinical aesthetic & clinical therapeutic in — Haircare, Skincare, and Medical Engineering — each built on the foundation of dermatological science with skin & hair care routine products validated through clinical evidence.`,
    <strong key="h1">Haircare:</strong>,
    ` Our portfolio includes topical and oral Minoxidil for chronic and acute hair loss, alongside nutraceutical formulations that provide essential nourishment, supporting healthy follicle cycles and long-term hair vitality.`,
    <strong key="h2">Skincare:</strong>,
    ` We address a wide spectrum of dermatological concerns including Photoaging, Dermal-epidermal pigmentation, Acne, Eczema, Psoriasis, Fungal and Parasitic infections, and Skin barrier disorders. Our range also extends to Immunity-boosting, Anti-allergic, and Photoprotective solutions, as well as Skin-soothing and Anti-inflammatory therapies.`,
    <strong key="h3">Medical Engineering:</strong>,
    ` Through innovation in medical devices and regenerative technologies, we empower healthcare professionals with advanced tools that enhance precision, improve safety, and deliver better patient outcomes.`,
    `Our mission is clear — to deliver evidence-based, science-driven solutions that restore, protect, and enhance skin and hair health, while advancing medical innovation for tomorrow.`,
  ];

  const workshops = [
    {
      title: "SkinnVersity Nx Workshop – Cochin, July 2023",
      images: [w1_1, w1_2, w1_3, w1_4, w1_5, w1_6],
    },
    {
      title: "SkinnVersity Nx Workshop – Mumbai, October 2023",
      images: [w2_1, w2_2, w2_3, w2_4, w2_5, w2_6],
    },
  ];

  /* ---------------- NEW : LIGHTBOX STATE ---------------- */
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentWorkshopImages, setCurrentWorkshopImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openLightbox = (images, index) => {
    setCurrentWorkshopImages(images);
    setCurrentIndex(index);
    setLightboxOpen(true);
  };

  const closeLightbox = () => setLightboxOpen(false);

  const nextImage = () => {
    setCurrentIndex((prev) =>
      prev === currentWorkshopImages.length - 1 ? 0 : prev + 1
    );
  };

  const prevImage = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? currentWorkshopImages.length - 1 : prev - 1
    );
  };

  /* ------------------------------------------------------ */

  return (
    <>
      <BreadcrumbSection
        title="An Academic Nexus for the Future of Dermatology"
        breadcrumbItems={[{ label: "Home", to: "/" }]}
        backgroundImage={BredcrumpImage}
      />

      <main className="learnings-page">
        <section className="section-title">
          <h2>Learnings</h2>
          <div className="underline" />
        </section>

        <section className="hero container">
          <div className="hero-left">
            <div className="hero-card">
              <p>{heroText[0]}</p>

              <p>
                <strong>Haircare:</strong>
                {heroText[2]}
              </p>

              <p>
                <strong>Skincare:</strong>
                {heroText[4]}
              </p>

              <p>
                <strong>Medical Engineering:</strong>
                {heroText[6]}
              </p>

              <p className="hero-ending">{heroText[7]}</p>
            </div>
          </div>

          <div className="hero-right">
            <div className="logo-wrap">
              <img src={demoLogo} alt="SkinnVersity Nx logo" />
            </div>
          </div>
        </section>

        <section className="workshops container">
          <h3 className="workshops-title">Workshops</h3>

          {workshops.map((group, idx) => (
            <div key={idx} className="workshop-group">
              <h4 className="workshop-heading">{group.title}</h4>

              <div className="gallery">
                {group.images.map((img, i) => (
                  <figure
                    key={i}
                    className="gallery-item"
                    onClick={() => openLightbox(group.images, i)}
                    style={{ cursor: "pointer" }}
                  >
                    <img src={img} alt={`${group.title} - ${i + 1}`} />
                  </figure>
                ))}
              </div>
            </div>
          ))}
        </section>
      </main>

      {/* ------------------- NEW LIGHTBOX MODAL ------------------ */}
      {lightboxOpen && (
        <div className="lightbox-overlay" onClick={closeLightbox}>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <img
              src={currentWorkshopImages[currentIndex]}
              alt="preview"
              className="lightbox-img"
            />

            <button className="lightbox-close" onClick={closeLightbox}>
              ×
            </button>

            <button className="lightbox-prev" onClick={prevImage}>
              ‹
            </button>
            <button className="lightbox-next" onClick={nextImage}>
              ›
            </button>
          </div>
        </div>
      )}
      {/* ------------------------------------------------------------ */}
    </>
  );
};

export default Learnings;
